module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/master-308ec35e4ba72d14febd72854620104d.png";